var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-max-w-7xl tw-py-6 tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-mx-auto tw-font-thin"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }